<template>
<div>

    <button type="button" class="btn btn-xs btn-success" @click="newModal"><i class="fa fa-plus" accesskey="g"></i> Ledger</button>
          
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">Add New</h4>
            </div>
            <form @submit.prevent="createLedger()">
              <div class="modal-body">
                  <!-- general form elements disabled -->
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group">
                            <label>Ledger <span class="red">*</span></label>
                            <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Alias <span class="red">*</span></label>
                            <input v-model="form.alias" type="text" name="alias" class="form-control" :class="{ 'is-invalid': form.errors.has('alias') }" />
                            <has-error :form="form" field="alias"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Group <span class="red">*</span></label>
                            <select v-model="form.group_id" name="group_id" class="form-control" :class="{'is-invalid': form.errors.has('group_id')}">
                              <option v-if="!form.group_id" selected value="">Select Group</option>
                              <option v-for="(group,index) in groups" :key="index" :value="group.id">{{group.group}}</option>
                            </select>
                            <has-error :form="form" field="group_id"></has-error>
                          </div>

                        </div>
                        <div class="col-sm-6">

                          <div class="form-group">
                            <label>OpeningBalance <span class="red">*</span></label>
                            <input v-model="form.openingBalance" type="text" name="openingBalance" class="form-control" :class="{ 'is-invalid': form.errors.has('openingBalance') }" />
                            <has-error :form="form" field="openingBalance"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Select Status <span class="red">*</span></label>
                            <select v-model="form.status" name="status" class="form-control" :class="{'is-invalid': form.errors.has('status')}">
                              <option v-if="!form.status" selected value="">Select Status</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
              </div>
              <div class="modal-footer text-center">
                <button type="submit" class="btn btn-success" > CREATE </button>
                <button type="button" class="btn btn-danger" data-dismiss="modal" > CANCEL</button>
              </div>
            </form>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
      
</div>
</template>

<script>
export default {
  name: 'Group',
  data () {
    return {
      form: new Form({
        id: '',
        name: '',
        alias: '',
        group: '',
        openingBalance: '',
        status: ''
      }),
      groups: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    newModal () {
      this.form.reset()
      $('#newModal').modal('show')
    },
    createLedger () {
      this.$axios
        .post('ledger', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          this.$parent.loadData()
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Ledger Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    loadData () {
      this.$axios
        .get('group?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.groups = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },

  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>



// WEBPACK FOOTER //
// AddLedger.vue?5eab01b2